import React, { useEffect, useState } from "react";
import "./Free_Consultation.css";
import { useNavigate } from "react-router-dom";

const Free_Consultation = () => {
  const navigate =useNavigate();



  return (
    <section className="Free_Consultation">
        <div className="Free_Consultation_div">

         

          <img onClick={() => navigate("/contact-us")} className="consult-banner" src={process.env.PUBLIC_URL + "/assets/images/home/free_consultation/get_cunsultacy.png"} />



        </div>

    </section>
  );
};

export default Free_Consultation;
